import { CountryCard } from '../country-card.model';
import { CountryCardActions, CountryCardActionTypes } from './country-card.actions';

export interface CountryCardState {
    countryCardList: CountryCard[];
    loaded: boolean;
}

export const initialState: CountryCardState = {
    countryCardList: [],
    loaded: false
};

export function countryCardReducer(state = initialState, action: CountryCardActions): CountryCardState {

    switch (action.type) {
        case CountryCardActionTypes.LoadCountryCardsSuccess:
            return {
                ...state,
                countryCardList: action.payload,
                loaded: true
            };
        case CountryCardActionTypes.UpdateCountryCardSuccess:
            {
                const newCountriesCards: CountryCard[] = [...state.countryCardList];
                const itemToUpdate = newCountriesCards.find((value) => {
                    return value.id === action.countryCard.id;
                });
                const index = newCountriesCards.indexOf(itemToUpdate);
                newCountriesCards[index] = action.countryCard;
                return {
                    ...state,
                    countryCardList: newCountriesCards
                };
            }
        case CountryCardActionTypes.CreateCountryCardSuccess:
            return {
                ...state,
                countryCardList: [...state.countryCardList, action.countryCard]
            };
        case CountryCardActionTypes.DeleteCountryCardSuccess:
            {
                const index = state.countryCardList.findIndex(u => u.id === action.countryCard.id);
                const newCountriesCards: CountryCard[] = [...state.countryCardList];
                newCountriesCards.splice(index, 1);
                return {
                    ...state,
                    countryCardList: newCountriesCards
                };
            }
        case CountryCardActionTypes.ClearCountryCards:
            return {
                ...state,
                loaded: false,
                countryCardList: []
            };
        default:
            return state;
    }
}
